module.exports = __webpack_public_path__ + "static/img/bridge.2b65169.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/address/bridge.jpg
// module id = 5Lr8
// module chunks = 0